<template>
  <div id="main">
    <div id="main2">
      <header>
        リアルタイム
        <div class="h-left">
          <a @click="refresh"><img src="~@/assets/images/icon04.svg" /></a>
        </div>
        <div class="h-right">
          <a @click="openSearch"><img src="~@/assets/images/icon03.svg" /></a>
        </div>
      </header>
      <div id="wrap2" class="show" style="min-height: 100vh">
        <div id="fbt">
          <div class="fbt">
            <a @click="$router.push({ name: 'timelineCreate' })">
              <div class="fbt08">
                <img src="~@/assets/images/fbt-iocn08.svg" />
              </div>
            </a>
          </div>
        </div>
        <div style="position: relative; margin-top: 50px" v-if="!isDeleted">
          <!-- <p style='font-size: 12px; margin-left: 2%;'>{{ date }}</p> -->
          <a
            @click="redirectDetail(item)"
            v-for="(item, i) in myTimelines"
            :key="i"
          >
            <div class="list"  style="border-bottom: none">
              <div class="clearfix">
                <div class="list-img">
                  <div class="list-image-name" style="position: relative;">
                    <img
                      v-if="item.avatar_url"
                      :src="getImageUrl(item.avatar_url)"
                    />
                    <div v-if="parseInt(item.checked_status) === PC_APPROVE" class="blurA">審査中</div>
                  </div>
                </div>
                <div class="list-inf">
                  <table>
                    <tr>
                      <td>
                        <p>
                          <span
                            ><span class="red b" v-if="item.is_new">NEW&nbsp;</span>
                            <span>{{ item.posted_at }}&nbsp;</span></span
                          >
                          <span class="list-name"
                            >{{ item.displayname }} {{ userDetail.age }}歳
                            {{ getLiving(item.living_area) }}</span
                          >
                        </p>
                      </td>
                    </tr>
                    <tr class="list-inf">
                      <td>
                        <p>
                          <span v-if="parseInt(item.sex) === FEMALE">
                            <span class="pink"
                              ><i class="fas fa-phone"></i>&nbsp;話{{
                                getCallStatus(item.enabled_call)
                              }}&nbsp;</span
                            >
                            <span
                              class="pink2"
                              v-if="
                                IS_WAITING_FOR_MEET === parseInt(item.is_free)
                              "
                            >
                              <i class="fas fa-calendar-check"></i>&nbsp;本日OK
                            </span>
                          </span>
                          <span v-else>
                              <span class="pink"> {{ getFieldProfile('income', item.income) }}</span>
                          </span>
                        </p>
                        <p>
                          {{ item.content }}
                        </p>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            
          </a>
        </div>
        <div v-else style="height: 8px"></div>
        
        <div class="real-select">
          <div id="real-select-btn" @click="isShowDateDialog = true">
            {{ search.date || "選択してください" }}
          </div>
        </div>
        <div>
          <div v-for="(date, index) in dateTL" :key="index">
            <!-- <p style="font-size: 12px; margin-left: 2%">{{ date }}</p> -->
            <a
              @click="redirectDetail(item)"
              v-for="(item, i) in arrayDate[date]"
              :key="i"
            >
              <div class="list">
                <div class="clearfix">
                  <div class="list-img">
                    <div class="list-image-name">
                      <img
                        v-if="item.avatar_url"
                        :src="getImageUrl(item.avatar_url)"
                      />
                    </div>
                  </div>
                  <div class="list-inf">
                    <table>
                      <tr>
                        <td>
                          <p>
                            <span
                              ><span class="red b" v-if="item.is_new">NEW&nbsp;</span>
                              <span>{{ item.posted_at}}&nbsp;</span> </span
                            >
                            <span class="list-name"
                              >{{ item.displayname }} {{ item.age }}歳
                              {{ getLiving(item.living_area) }}</span
                            >
                          </p>
                        </td>
                      </tr>
                      <tr class="list-inf">
                        <td>
                          <p>
                            <span v-if="parseInt(item.sex) === FEMALE">
                              <span class="pink"
                                ><i class="fas fa-phone"></i> 通話{{
                                  getCallStatus(item.enabled_call)
                                }}&nbsp;</span
                              >
                              <span
                                class="pink2"
                                v-if="
                                  IS_WAITING_FOR_MEET === parseInt(item.is_free)
                                "
                              >
                                <i class="fas fa-calendar-check"></i> 本日OK
                              </span>
                            </span>
                            <span v-else>
                              <span class="pink"> {{ getFieldProfile('income', item.income) }}</span>
                            </span>
                          </p>
                          <p>
                            {{ item.content }}
                          </p>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <infinite-loading
            @infinite="getTimeline"
            spinner="spiral"
            :identifier="infiniteId"
          >
            <template v-slot:no-more></template>
            <template v-slot:no-results>
              <div id="middle">{{ resultMessage }}</div>
            </template>
          </infinite-loading>
        </div>
      </div>
    </div>
    <div v-if="isSearch" id="search" class="hidden-right">
      <search @close="saveDataSearch" :dataSearch="dataSearch" />
    </div>
  </div>
  <div id="detail-main" class="hidden-detail">
    <detail
      v-if="isShowDetail"
      :isShow="isShowDetail"
      @close="closeDetail"
      :timelineDetail="timelineDetail"
    ></detail>
  </div>
  <div class="loading-screen" v-if="isLoading">
    <div class="loader"></div>
  </div>

  <SelectDateDialog
      v-if="isShowDateDialog"
      title="募集日"
      :date="search.date"
      @save="handleSelectDate"
      @close="closeSelectDateDialog"
  />
</template>

<script>
import CONSTANTS from "@/constants";
import detail from "./detail";
import { mapGetters, mapActions } from "vuex";
import mixin from "@/mixin";
import search from "./search";
import SelectDateDialog from "./selectDateDialog.vue";
export default {
  components: {
    search,
    detail,
    SelectDateDialog
  },
  mixins: [mixin],
  data: () => ({
    pageSize: CONSTANTS.DEFAULT_PAGE_SIZE,
    IS_WAITING_FOR_MEET: CONSTANTS.IS_WAITING_FOR_MEET,
    FEMALE: CONSTANTS.FEMALE,
    pageCurrent: 1,
    timelines: [],
    search: {
      date: new Date(),
    },
    myTimelines: [],
    infiniteId: +new Date(),
    arrayDate: [],
    dateTL: [],
    isSearch: false,
    dataSearch: null,
    isLoading: true,
    scrollHeight: null,
    isShowDetail: false,
    timelineDetail: null,
    resultMessage: "検索結果０件です",
    isDeleted: false,
    PC_APPROVE: CONSTANTS.PC_APPROVE,
    isShowDateDialog: false,
  }),
  mounted() {
    this.setFooter(true);
    this.search.date = this.formatDateTime(this.search.date);
  },
  computed: {
    ...mapGetters(["metadata", "defaultToken",  "userDetail"]),
  },
  watch: {
    isShowDetail(val) {
        const body = document.getElementsByTagName('body')[0];
        if (val) body.style.overflow = "hidden";
        else body.style.overflow = "auto";
    },
    isSearch(val) {
        const body = document.getElementsByTagName('body')[0];
        if (val) body.style.overflow = "hidden";
        else body.style.overflow = "auto";
    },
    
    isShowDateDialog(val) {
      if (val) {
        this.setFooter(false)
        document.getElementsByTagName('body')[0].style.overflow = "hidden";
        document.getElementById('app').style.overflow = "hidden";
        document.getElementById('app').style.height = "calc(100vh - 1px)";
      }
      else {
        this.setFooter(true)
        document.getElementsByTagName('body')[0].style.overflow = "auto";
        document.getElementById('app').style.overflow = "";
        document.getElementById('app').style.height = "";
      }
    },

    "search.date"() {
      this.searchTimeline()
    }
  },
  methods: {
    ...mapActions({
      setFooter: "layout/setFooter",
    }),
    closeDetail(val) {
      document.getElementById("main").style.display = "unset";
      document.getElementById("detail-main").classList.add("hidden-detail");
      document.getElementById("detail-main").classList.remove("show-detail");
      this.isShowDetail = false;
      this.setFooter(true);
      if (val === true) {
        this.isDeleted = val;
      }
      if (val && typeof val === "object" && this.myTimelines.length > 0) {
        this.myTimelines[0].content = val.content;
      }
      setTimeout(() => {
        window.scrollTo(0, this.scrollHeight);
      }, 1);
    },
    openSearch() {
      this.isSearch = true;
      document.getElementById("main2").classList.remove("show");
      document.getElementById("main2").classList.add("hidden");
      setTimeout(() => {
        document.getElementById("search").classList.remove("hidden-right");
        document.getElementById("search").classList.add("show-right");
      }, 0);
      this.setFooter(false);
    },
    saveDataSearch(data) {
      this.isSearch = false;
      document.getElementById("search").classList.add("hidden-right");
      document.getElementById("search").classList.remove("show-right");
	  setTimeout(() => {
		document.getElementById("main2").classList.add("show");
      	document.getElementById("main2").classList.remove("hidden");
	  }, 100)
      this.dataSearch = data;
    },
    async redirectDetail(item) {
      this.setFooter(false);
      this.scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
      document.getElementById("main").style.display = "none";
	  document.getElementById("detail-main").classList.add("show-detail");
      document.getElementById("detail-main").classList.remove("hidden-detail");
	  this.isShowDetail = true;
      await this.$store
        .dispatch("timeline/getTimelineDetail", {
          token: this.defaultToken,
          user_id: item.user_id,
          keijiban_id: item.id,
        })
        .then((data) => {
          this.timelineDetail = data;
        })
        .catch((err) => {
          console.log(err);
        });
			  
    },
    async refresh() {
      this.isLoading = true;
      this.timelines = [];
      this.arrayDate = [];
      this.dateTL = [];
      this.pageCurrent = 1;
      this.search.date = this.formatDateTime(new Date());
      this.infiniteId++;
    },
    async searchTimeline() {
      this.timelines = [];
      this.arrayDate = [];
      this.dateTL = [];
      this.pageCurrent = 1;
      this.infiniteId++;
    },
    getDaysArray(start, end) {
      let days = [];
      for (
        let dt = new Date(end);
        dt >= new Date(start);
        dt.setDate(dt.getDate() - 1)
      ) {
        days.push(new Date(dt));
      }
      days = days.map((v) => {
        return this.formatDateTime(v);
      });
      return days;
    },
    getLiving(id) {
      if (!this.metadata.user_profile_list) return;
      let living = this.metadata.user_profile_list.living_area.filter(
        (item) => {
          return item.value === id;
        }
      );
      if (living[0]) {
        return living[0].name;
      }
      return null;
    },

    async getTimeline($state = null) {
      if (
        this.timelines.length > 0 &&
        this.timelines.length < this.pageSize &&
        $state
      ) {
        this.resultMessage = "";
        $state.complete();
        return;
      } else {
        this.resultMessage = "検索結果０件です";
      }
      let params = {
        free_at: this.search.date,
        page: this.pageCurrent,
        limit: this.pageSize,
        token: this.defaultToken,
      };
      await this.$store
        .dispatch("timeline/getTimeline", params)
        .then((data) => {
          this.myTimelines = data.my_result;
          this.$store.dispatch('timeline/setMyTimeline', this.myTimelines)
          if (data.result.length > 0) {
            data.result = data.result.filter((item) => {
              return item.category_id !== 0;
            });
          }
          if (data.result.length > 0) {
            this.pageCurrent++;
            this.timelines.push(...data.result);
            this.timelines = this.timelines.sort((a, b) => {
              if (new Date(a.created_at) > new Date(b.created_at)) return -1;
              if (new Date(a.created_at) < new Date(b.created_at)) return 1;
              return 0;
            });
            this.dateTL = this.timelines.map((item) => {
              return this.formatDateTime(item.created_at);
            });
            this.dateTL = Array.from(new Set(this.dateTL));
            for (let i = 0; i < this.dateTL.length; i++) {
              let arr = this.timelines.filter((e) => {
                return this.formatDateTime(e.created_at) == this.dateTL[i];
              });
              if (arr.length > 0) {
                this.arrayDate[this.dateTL[i]] = arr;
              }
            }
            this.dateTL.filter((item) => {
              if (this.arrayDate[item]) {
                return true;
              }
              return false;
            });
            if ($state) {
              $state.loaded();
            }
          } else {
            if ($state) {
              $state.complete();
            }
          }
        })
        .catch((err) => {
          if ($state) {
            $state.complete();
          }
        });
      this.isLoading = false;
    },
    getFieldProfile(field, id) {
      if (!this.metadata) return null
      let filedData = this.metadata.user_profile_list[field].filter((item) => {
          return parseInt(item.value) === parseInt(id);
      });
      if (filedData[0]) {
          return filedData[0].name;
      }
      return CONSTANTS.NOT_VALUE;
    },
    
    handleSelectDate(selectedDate) {
        this.isShowDateDialog = false
        this.search.date = this.formatDateTime(selectedDate)
    },
    closeSelectDateDialog() {
        this.isShowDateDialog = false
    }
  },
};
</script>
<style scoped>
.hidden {
  display: none;
}
.show {
  display: block;
}
.hidden-right {
  position: fixed;
  right: -100%;
  opacity: 0;
}
.show-right {
  position: fixed;
  right: 0;
  opacity: 1;
}
#list {
  transition: all 0.2s;
}
#main {
  width: 100%;
  height: 100%;
  display: unset;
}
#search {
  width: 100%;
  transition: all 0.2s;
}
#main-search {
  transition: all 0.2s;
}
#wrap {
  margin-top: 0px;
}
.hidden-detail {
  height: 0px;
  width: 0px;
  transform: scale(0, 0);
  overflow: hidden;
}
.show-detail {
  transform: scale(1, 1);
  height: 100%;
  width: 100%;
  overflow: unset;
}
#detail-main {
  transition: all 0.2s;
  top: 0;
  position: fixed;
}
.blurA {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #00000066;
  color: #fff;
  border-radius: 100%;
}
#real-select-btn{
  border: 1px solid black;
  padding: 6px;
  text-align: center;
  margin: 8px;
  border-radius: 4px;
}
</style>
